// Shared Google Geocoding + Places helpers for the browser.
// Uses REACT_APP_GOOGLE_MAPS_API_KEY (the same key configured in capacitor / web).
// All results are cached in localStorage so repeated lookups are free.
import { isGoogleEnabled, trackGoogle } from './googleApiTrack';

const KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const CACHE_PREFIX = 'carloo_geo_';

const cacheKey = (lat, lng) => `${CACHE_PREFIX}${lat.toFixed(5)},${lng.toFixed(5)}`;

/**
 * Reverse-geocode a coordinate to a human address.
 * Returns { formatted, short } where `short` is best-effort 2 lines.
 * Returns null on failure (caller should fall back to coords).
 */
export async function reverseGeocode(lat, lng) {
  if (!KEY || lat == null || lng == null) return null;
  const k = cacheKey(lat, lng);
  try {
    const cached = localStorage.getItem(k);
    if (cached) return JSON.parse(cached);
  } catch {}

  // Respect the admin Google API toggle — when disabled we still
  // serve cached values (above) but never hit Google for a fresh lookup.
  if (!(await isGoogleEnabled('geocode_reverse'))) return null;

  try {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${KEY}`;
    const r = await fetch(url);
    if (!r.ok) { trackGoogle('geocode_reverse', 'staff', false); return null; }
    const j = await r.json();
    if (j.status !== 'OK' || !j.results?.length) {
      trackGoogle('geocode_reverse', 'staff', false);
      return null;
    }
    const top = j.results[0];
    const result = {
      formatted: top.formatted_address,
      short: top.formatted_address.split(',').slice(0, 2).join(', ').trim()
    };
    try { localStorage.setItem(k, JSON.stringify(result)); } catch {}
    trackGoogle('geocode_reverse', 'staff', true);
    return result;
  } catch {
    trackGoogle('geocode_reverse', 'staff', false);
    return null;
  }
}
